module.exports = __webpack_public_path__ + "static/media/kids_32.a9c1cb63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_32.jpg
// module id = 5888
// module chunks = 0